import { render, staticRenderFns } from "./m-tiptap.vue?vue&type=template&id=501827bd&scoped=true"
import script from "./m-tiptap.vue?vue&type=script&lang=js"
export * from "./m-tiptap.vue?vue&type=script&lang=js"
import style0 from "./m-tiptap.vue?vue&type=style&index=0&id=501827bd&prod&lang=scss"
import style1 from "./m-tiptap.vue?vue&type=style&index=1&id=501827bd&prod&lang=scss&scoped=true"
import style2 from "./m-tiptap.vue?vue&type=style&index=2&id=501827bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501827bd",
  null
  
)

export default component.exports